// extracted by mini-css-extract-plugin
export default {"dark-mode-switch":"styles_dark-mode-switch__pDNiR"};